export const SITE = {
  name: "AriDanya Garden",
  tagline: "Pool & Lounge",
  motto: "Relaxare. Distracție. Amintiri frumoase.",
  phone: "0775316398",
  phoneDisplay: "0775 316 398",
  phoneHref: "tel:+40775316398",
  whatsappHref: "https://wa.me/40775316398",
  location: "Giulești, București",
  logo: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/iiiq1vff_WhatsApp%20Image%202026-06-08%20at%2020.57.35.jpeg",
};

export const GALLERY_CATEGORIES = [
  {
    id: "petreceri-private",
    label: "Petreceri private",
    description: "Aniversări, întâlniri cu prietenii și evenimente private pentru adulți.",
    photos: [
      { url: "https://customer-assets-agu9un31.emergentagent.net/job_tropical-pool-party/artifacts/gxidtiyw_WhatsApp%20Image%202026-09-27%20at%2021.14.27.jpeg" },
      { url: "https://customer-assets-agu9un31.emergentagent.net/job_tropical-pool-party/artifacts/3eg34b1b_WhatsApp%20Image%202026-09-27%20at%2021.14.27%20%281%29.jpeg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/tm8zgc3t_DSC02005.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/872jlvre_DSC02019.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/4nejhch6_DSC02027.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/4q3mghlj_DSC02088.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/y83nanti_DSC02093.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/55dxqvap_DSC02006.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/i81rz437_DSC01966.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/qexui3l3_DSC02058.jpg" },
    ],
  },
  {
    id: "petreceri-copii",
    label: "Petreceri copii",
    description: "Aniversări și zile de naștere pentru cei mici, cu piscină și tobogan.",
    photos: [
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/d0zslk8t_DSC01994.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/4e0dcjoe_DSC02058.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/sgzn1zt0_DSC02110.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/ig3easlc_DSC02191.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/vfvej8nu_DSC02242.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/n7c9fovd_DSC01984.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/pkyel9xc_DSC01988.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/50uer3gy_DSC02124.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/7wbvvcvl_DSC02128.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/4ginq1hz_DSC02169.jpg" },
    ],
  },
  {
    id: "botezuri-cununii",
    label: "Botezuri & Cununii",
    description: "Decoruri elegante și aranjamente florale pentru cele mai speciale momente.",
    photos: [
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/ft61j2dn_DSC01897.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/oeyoxika_DSC01904.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/3fb4r1s7_DSC01918.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/119pyin4_DSC01885.jpg" },
      { url: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/hfkfr560_DSC01926.jpg" },
    ],
  },
];

export const STOCK = {
  heroLeaves: "https://customer-assets.emergentagent.com/job_tropical-pool-party/artifacts/c6akmnmf_DSC01885.jpg",
  poolAmbient: "https://images.unsplash.com/photo-1572477722570-8a909f42ca6d?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  palms: "https://images.unsplash.com/photo-1525923838299-2312b60f6d69?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
};

export const FACILITIES = [
  { icon: "Waves", title: "Piscină 10×5m", desc: "Adâncime 1.30m." },
  { icon: "Anchor", title: "Tobogan gonflabil", desc: "Pentru copii de la 3 până la 8 ani, chiar lângă piscină." },
  { icon: "UtensilsCrossed", title: "Terasă acoperită", desc: "Spațiu acoperit pentru servit masa, capacitate până la 70 de persoane." },
  { icon: "Martini", title: "Bar exterior", desc: "Bar din lemn natural pentru servire băuturi și cocktailuri." },
  { icon: "Bath", title: "Grupuri sanitare", desc: "Toalete curate și accesibile, gândite pentru confortul invitaților." },
  { icon: "Flower2", title: "Grădină verde", desc: "Iarbă proaspătă, plante decorative — un mic colț de oază." },
  { icon: "Flame", title: "Grătar", desc: "Grătar disponibil pentru preparate sub cerul liber." },
  { icon: "Flame", title: "Vatră de foc", desc: "Vatră de foc pentru serile răcoroase și o atmosferă primitoare." },
];

export const PRICING = [
  {
    title: "Weekend · Toată ziua",
    subtitle: "Program 14:00–06:00",
    price: "2500",
    badge: "Popular",
    features: [
      "Acces exclusiv la locație",
      "Piscină",
      "Tobogan gonflabil",
      "Terasă acoperită pentru servirea mesei",
      "Amenajarea meselor pentru copii și adulți",
      "Grădină și zonă de relaxare",
      "Vatră de foc",
      "Parcare disponibilă",
    ],
  },
  {
    title: "Săptămână · Toată ziua",
    subtitle: "Program 14:00–06:00",
    price: "1500",
    badge: null,
    features: [
      "Acces exclusiv la locație",
      "Piscină",
      "Tobogan gonflabil",
      "Terasă acoperită pentru servirea mesei",
      "Amenajarea meselor pentru copii și adulți",
      "Grădină și zonă de relaxare",
      "Vatră de foc",
      "Parcare disponibilă",
    ],
  },
];

export const NAV = [
  { id: "acasa", label: "Acasă" },
  { id: "despre", label: "Despre" },
  { id: "facilitati", label: "Facilități" },
  { id: "preturi", label: "Prețuri" },
  { id: "galerie", label: "Galerie" },
  { id: "contact", label: "Contact" },
];
